export default "__VITE_ASSET__8195a50d__"